import React, { Suspense, lazy } from 'react'
import './HomePage.css'
import { Navbar } from '../../components/home'

const Hero = lazy(() => import('../../components/home/Hero'))
const About = lazy(() => import('../../components/home/About'))
const GameGallery = lazy(() => import('../../components/home/GameGallery'))
const Footer = lazy(() => import('../../components/home/Footer'))

const HomePage = () => {
  return (
    <div className='relative z-0 bg-primary text-white'>
      <div className='bg-hero-pattern bg-cover bg-no-repeat bg-center'>
        <Navbar />
        <Suspense fallback={<div className='relative w-full h-screen mx-auto'>...</div>}>
          <Hero />
        </Suspense>
      </div>
      <Suspense fallback={null}>
        <About />
      </Suspense>
      <Suspense fallback={null}>
        <GameGallery />
      </Suspense>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  )
}

export default HomePage
